import React, { useEffect, useRef, useState } from "react";
import Header from "../../../Componets/Header";
import { useLocation } from "react-router-dom";
import suppliers from "../../../Data/suppliers.json";
import toast from "react-hot-toast";
import moment from "moment";
import Loadercomponent from "../../../Componets/Loader";
import { get_all_purchases_returns } from "../../../Controllers/Purchases/Returns";
import ScrollWrapper from "../../../Componets/ScrollWrapper";
import formatDateDDMMYYYY from "../../../Main/formatDate";
import ReactToPrint from "react-to-print";
import { Button } from "antd";
import { PrinterOutlined } from "@ant-design/icons";

const PurchaseReportDashboard = () => {
  let componentRef = useRef();

  const [loader, setLoader] = useState(false);
  const [body, setBody] = useState();

  const headers = {
    name: "Purchase Returns",
    components: [
      {
        type: "search",
        name: "search",
        placeholder: "Search",
        value: "",
      },
      {
        type: "select",
        name: "sort",
        placeholder: "Sort",
        allowClear: true,
        showSearch: false,
        filterOption: true,
        value: null,
        options: [
          { value: "0", label: "Price (Low-High)" },
          { value: "1", label: "Price (High-Low)" },
        ],
      },
      {
        type: "filter",
        name: "supplier",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        placeholder: "Supplier",
        api: "get-all-suppliers",
        value: null,
        options: null,
      },
      {
        type: "filter",
        name: "branch",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        placeholder: "Branch",
        api: "get-all-branches",
        value: null,
        options: null,
      },
      /* {
        type: "filter",
        name: "status",
        placeholder: "Status",
        value: null,
        allowClear: true,
        showSearch: false,
        filterOption: true,
        options: [
          { value: "0", label: "Inactive" },
          { value: "1", label: "Active" },
        ],
      }, */
      {
        type: "range",
        name: "date",
        value: {
          start: "",
          end: "",
        },
      },
      {
        type: "range",
        name: "due_date",
        value: {
          start: "",
          end: "",
        },
      },
    ],
  };

  const [header, setHeader] = useState(headers);

  const formdata = (data) => {
    fetchData(data);
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const data = {
        search: tabledata?.search,
        sort: tabledata?.sort,
        supplier: tabledata?.supplier,
        branch: tabledata?.branch,
        status: tabledata?.status,
        date: tabledata?.date,
        due_date: tabledata?.due_date,
        source: "dashboard_purchase_return_report"
      };

      const products = await get_all_purchases_returns(data);
      if (products?.status) {
        setBody(products?.data?.data);
        setLoader(false);
      } else {
        toast?.error(products?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);


  const getPaymentAmount = (payments = [], type) => {
    return payments
      ?.filter(p => p?.name?.toLowerCase() === type.toLowerCase())
      ?.reduce((sum, p) => sum + Number(p?.amount || 0), 0);
  };

  const getPaidAmount = (payments = []) => {
    return payments?.reduce(
      (sum, p) => sum + Number(p?.amount || 0),
      0
    );
  };

  const getPayableAmount = (total = 0, payments = []) => {
    const paid = getPaidAmount(payments);
    return Number(total || 0) - paid;
  };

  const pageStyle = `
  @page {
    size: A4 landscape;
    margin: 10mm;
  }

  @media print {
    body {
      -webkit-print-color-adjust: exact;
    }

    table {
      width: 100%;
      border-collapse: collapse;
    }
  }
`;

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <div className="text-end">
        <div className="py-2">
          <ReactToPrint
            trigger={() => (
              <Button
                className="bg-white border rounded border-green-500 hover:border-green-900"
                type="button"
                size="large"
              >
                A4 Print <PrinterOutlined className="text-lg" />
              </Button>
            )}
            content={() => componentRef}
            pageStyle={pageStyle}
          />
        </div>
      </div>
      <Loadercomponent loader={loader}>
        <ScrollWrapper>
          <table className="w-full bg-white mt-4" ref={(el) => (componentRef = el)}>
            <thead className="text-gray-500">
              <tr>
                <td className="border p-4">Purchase Return</td>
                <td className="border p-4">Supplier</td>
                <td className="border p-4">Branch</td>
                <td className="border p-4">Date</td>
                <td className="border p-4">Cash</td>
                <td className="border p-4">Debit</td>
                <td className="border p-4">Credit</td>
                <td className="border p-4">Bank</td>
                <td className="border p-4">Online</td>
                <td className="border p-4">Cheque</td>
                <td className="border p-4">Paid</td>
                <td className="border p-4">Payable</td>
                <td className="border p-4">Subtotal</td>
                <td className="border p-4">Tax&nbsp;[VAT]</td>
                <td className="border p-4">Total</td>
              </tr>
            </thead>
            <tbody>
              {body?.map((value, index) => {
                return (
                  <tr>
                    <td className="border p-4">#PR-{value?.number}</td>
                    <td className="border p-4">{value?.supplier?.name}</td>
                    <td className="border p-4">{value?.branch?.name}</td>
                    <td className="border p-4">
                      {value?.date
                        ? formatDateDDMMYYYY?.(value?.date)
                        : ""}
                    </td>
                    <td className="border p-2">
                      {getPaymentAmount(value?.payments, "Cash").toFixed(3)}
                    </td>

                    <td className="border p-2">
                      {getPaymentAmount(value?.payments, "Debit card").toFixed(3)}
                    </td>

                    <td className="border p-2">
                      {getPaymentAmount(value?.payments, "Credit card").toFixed(3)}
                    </td>

                    <td className="border p-2">
                      {getPaymentAmount(value?.payments, "Bank transfer").toFixed(3)}
                    </td>

                    <td className="border p-2">
                      {getPaymentAmount(value?.payments, "Online payment").toFixed(3)}
                    </td>

                    <td className="border p-2">
                      {getPaymentAmount(value?.payments, "Cheque").toFixed(3)}
                    </td>
                    <td className="border p-2">
                      {value?.payments
                        ?.reduce((sum, p) => sum + Number(p?.amount || 0), 0)
                        .toFixed(3)}
                    </td>
                    <td className="border p-2">
                      {getPayableAmount(value?.total, value?.payments).toFixed(3)}
                    </td>
                    <td className="border p-4">
                      {value?.subtotal?.toFixed?.(3)}
                    </td>
                    <td className="border p-4">
                      {value?.taxamount?.toFixed?.(3)}
                    </td>
                    <td className="border p-4">{value?.total?.toFixed?.(3)}</td>
                  </tr>
                );
              })}
            </tbody>
            <tfoot>
              <td className="border p-4"></td>
              <td className="border p-4"></td>
              <td className="border p-4"></td>
              <td className="border p-4"></td>
              <td className="border p-2">
                {body
                  ?.reduce(
                    (acc, cur) => acc + getPaymentAmount(cur?.payments, "Cash"),
                    0
                  )
                  .toFixed(3)}
              </td>
              <td className="border p-2">
                {body
                  ?.reduce(
                    (acc, cur) => acc + getPaymentAmount(cur?.payments, "Debit card"),
                    0
                  )
                  .toFixed(3)}
              </td>
              <td className="border p-2">
                {body
                  ?.reduce(
                    (acc, cur) => acc + getPaymentAmount(cur?.payments, "Credit card"),
                    0
                  )
                  .toFixed(3)}
              </td>
              <td className="border p-2">
                {body
                  ?.reduce(
                    (acc, cur) => acc + getPaymentAmount(cur?.payments, "Bank transfer"),
                    0
                  )
                  .toFixed(3)}
              </td>
              <td className="border p-2">
                {body
                  ?.reduce(
                    (acc, cur) => acc + getPaymentAmount(cur?.payments, "Online payment"),
                    0
                  )
                  .toFixed(3)}
              </td>
              <td className="border p-2">
                {body
                  ?.reduce(
                    (acc, cur) => acc + getPaymentAmount(cur?.payments, "Cheque"),
                    0
                  )
                  .toFixed(3)}
              </td>
              <td className="border p-2">
                {body
                  ?.reduce(
                    (acc, cur) =>
                      acc +
                      cur?.payments?.reduce(
                        (s, p) => s + Number(p?.amount || 0),
                        0
                      ),
                    0
                  )
                  .toFixed(3)}
              </td>
              <td className="border p-2">
                {body
                  ?.reduce(
                    (acc, cur) =>
                      acc + getPayableAmount(cur?.total, cur?.payments),
                    0
                  )
                  .toFixed(3)}
              </td>
              <td className="border p-4">
                {body
                  ?.reduce(
                    (acc, currentValue) =>
                      parseFloat(acc) + parseFloat(currentValue?.subtotal),
                    0
                  )
                  ?.toFixed(3)}
              </td>
              <td className="border p-4">
                {body
                  ?.reduce(
                    (acc, currentValue) =>
                      parseFloat(acc) + parseFloat(currentValue?.taxamount),
                    0
                  )
                  ?.toFixed(3)}
              </td>
              <td className="border p-4">
                {body
                  ?.reduce(
                    (acc, currentValue) =>
                      parseFloat(acc) + parseFloat(currentValue?.total),
                    0
                  )
                  ?.toFixed(3)}
              </td>
            </tfoot>
          </table>
        </ScrollWrapper>
      </Loadercomponent>
    </Header>
  );
};

export default PurchaseReportDashboard;
